import { render, staticRenderFns } from "./semdata.vue?vue&type=template&id=57d16cf6&"
import script from "./semdata.vue?vue&type=script&lang=js&"
export * from "./semdata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports